import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { decryptPledgeData } from 'src/app/shared/crypto-js/crypto-js';
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private cookie: CookieService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token: string | null = null;
    let ant_decode:string|null =null;

    if (request.url.includes('ekyc-api')) {
      const encryptedUserSession = localStorage.getItem('encryptedUserSession');
    
      if (encryptedUserSession) {
        const decryptedStr = decryptPledgeData(encryptedUserSession);
        // console.log(decryptedStr)
        const decryptedData = JSON.parse(decryptedStr);
        token = decryptedData.token;
      }
    } else {
      // if (this.cookie.check('gotoken')) {
      //   token = JSON.parse(this.cookie.get('gotoken')); 
      // }

      const gotoken = localStorage.getItem('got');
    
      if (gotoken) {
        const decryptedgotoken = decryptPledgeData(gotoken);
        // console.log(decryptedgotoken)
        // const decryptedData = JSON.parse(decryptedgotoken);
        token = decryptedgotoken
      }
    }
    // const antsession = localStorage.getItem('antsession')

    // if(antsession){
    //   const antsessiondecode = atob(antsession)
    //   ant_decode = antsessiondecode

    // }

    // Keep Authorization set by the caller (e.g. ant_session Bearer on /auth/fetchSession)
    if (token && !request.headers.has('Authorization')) {
      request = this.addToken(request, token);
    }

    return next.handle(request);
  }

  // private addToken(request: HttpRequest<any>, token: string) {
  //   return request.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${token}`,
  //       // if(request.url.includes('ekycuat-api')
  //       // Antsession:''
  //     },
  //   });
  // }
private addToken(request: HttpRequest<any>, token: string) {

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };

  // if (request.url.includes('ekycuat-api')) {

  //   const antsession = localStorage.getItem('antsession');

  //   if (antsession) {
  //     headers['Antsession'] = atob(antsession);  
  //   }
  // }

  return request.clone({ setHeaders: headers });
}
}
